import React from "react";

import LOGO_SVG from "../assets/icons/logo.svg";

export default function Logo({ className = "", light = false }) {
  return (
    <img
      src={LOGO_SVG}
      alt="My Couponbook"
      className={`auth-logo ${light ? "auth-logo-light" : ""} ${className}`}
    />
  );
}